<template>  
        <timeline-list title="Zaman qrafiki" dark-mode>
          <timeline-item
            color="excel"
            icon_color="excel"
            icon="check-bold"
            title="Ərizə daxil olunub"
            date-time="02.09.2025 13:00"
            dark-mode
          />
          <TimelineItem
            color="excel"
            icon_color="excel"
            icon="check-bold"
            title="Təstiqə göndərilib"
            date-time="02.09.2025 13:10"
            dark-mode
          />
          <TimelineItem
            color="danger"
            icon_color="danger"
            icon="bi bi-exclamation-triangle-fill mb-1"
            title="Anderaytinq təstiq"
            date-time="04.09.2025 16:10"
            description="Sığorta haqqı və komissiya dəyişilib"
            :badges="['Deadline', '03.09.2025 13:00', 'Gecikmiş']"
            dark-mode
          />
          <TimelineItem
            color="danger"
            icon_color="excel"
            icon="check-bold"
            title="Müqavilə yaranıb"
            date-time="04.09.2025 16:50"
            :badges="['Deadline', '05.09.2025 12:00']"
            dark-mode
          />
          <TimelineItem 
            icon="bi bi-hourglass-split mb-1"
            :done="false"
            title="Sığortaçı imzası" 
            color="excel"
            :badges="['No Deadline']" 
            dark-mode
          />
          <TimelineItem 
            icon="bi bi-hourglass-split mb-1"
            :done="false"
            title="Müştəri imzası"
            color="excel"
            :badges="['No Deadline']"
            dark-mode
          />
          <TimelineItem 
            icon="bi bi-hourglass-split mb-1"
            :done="false"
            title="Kurator imzası"
            color="excel"
            :badges="['No Deadline']"
            dark-mode
          />
          <TimelineItem
            icon="bi bi-hourglass-split mb-1"
            :done="false"
            title="Bildiriş"
            color="excel"
            :badges="['No Deadline']"
            dark-mode
          />
        </timeline-list> 
</template>

<script>
import TimelineList from "./Components/TimelineList.vue";
import TimelineItem from "./Components/TimelineItem.vue";
export default {
  name: "Timeline",
  components: { TimelineList, TimelineItem },
};
</script>
